import React from "react"

import styled from "styled-components"

const Burger = ({ isOpen, burgerToggle }) => {
  return (
    <BurgerButton onClick={burgerToggle} isOpen={isOpen}>
      <Line />
      <Line />
      <Line />
    </BurgerButton>
  )
}

const BurgerButton = styled.button`
  font-size: 0;
  right: 0%;
  cursor: pointer;
  position: relative;
  height: 1.25rem;
  width: 1.5625rem;
  background-color: transparent;
  z-index: 20;
  border: 0;
  transition: 0.3s;
  transform: ${({ isOpen }) => (isOpen ? "translateX(-7vw)" : "translateX(0)")};
  
  span {
    &:nth-child(1) {
      transform: ${({ isOpen }) => (isOpen ? "rotate(45deg)" : "rotate(0)")};
      top: ${({ isOpen }) => (isOpen ? "8px" : "0px")};
      position: ${({ isOpen }) => (isOpen ? "absolute" : "absolute")};
    }
    &:nth-child(2) {
      transform: ${({ isOpen }) =>
        isOpen ? "translateX(0)" : "translateX(0)"};
      opacity: ${({ isOpen }) => (isOpen ? 0 : 1)};
      top: 7px;
      position: ${({ isOpen }) => (isOpen ? "absolute" : "absolute")};
    }
    &:nth-child(3) {
      transform: ${({ isOpen }) => (isOpen ? "rotate(-45deg)" : "rotate(0)")};
      top: ${({ isOpen }) => (isOpen ? "8px" : "14px")};
      position: ${({ isOpen }) => (isOpen ? "absolute" : "absolute")};
    }
  }

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
      display: none;
    }
  }
`

const Line = styled.span`
  position: absolute;
  width: 100%;
  height: 5px;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.3s;
  border-radius: 3px;
  background-color: white;
`

export { Burger }
